
import { Outlet, useNavigate } from "react-router-dom";
import { AdminLayout, AppHeaderTitle, AppHeaderProfile, AppHeader, AppMain, MainContent, 
    AppLayoutContainer, AppHeaderLogoContainer, LogoImage, AppHeaderWrapper, 
    AppHeaderMenuIcon, AppHeaderProfileInfo,
    AppHeaderProfileAvatar,
    AppHeaderTools,
    LogoutButton} from "./Components";
import SideMenu from "../components/SideMenu/SideMenu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUserAlt, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { useApp } from "../hooks/useApp";
import { useAuth } from "../hooks/useAuth";
import { useState } from "react";
import { useModal } from "../hooks/useModal";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../services/constants";
const AppLayout = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {toggleSidebar, isShowSideBar} = useApp();
    const {openConfirm} = useModal();
    const [title, setTitle] = useState(null);
    const {user, logout} = useAuth();
    const onLogout = (e) => {
        openConfirm(t("Are you sure you want to do logout?"), logout)
    }
    return (
        <AppLayoutContainer>
            <AppHeader>
                <AppHeaderLogoContainer>
                    <AppHeaderMenuIcon onClick={(e) => toggleSidebar()} className={isShowSideBar?"":"active"}>
                        {!isShowSideBar?<FontAwesomeIcon icon={faBars} />:<FontAwesomeIcon icon={faBars} />}
                    </AppHeaderMenuIcon>
                    <LogoImage src="/assets/images/logo.png" />
                </AppHeaderLogoContainer>
                <AppHeaderWrapper>
                    <AppHeaderTitle>
                        {title}
                    </AppHeaderTitle>
                    <AppHeaderTools>
                        <LogoutButton onClick={onLogout}>
                            <FontAwesomeIcon icon={faPowerOff} />
                        </LogoutButton>
                    </AppHeaderTools>
                </AppHeaderWrapper>
            </AppHeader>
            <AppMain>
                <AdminLayout >
                    <SideMenu />
                    <MainContent $isShowSideBar={isShowSideBar}>
                        <Outlet context={{
                            setPageTitle: setTitle
                        }}/>
                    </MainContent>
                </AdminLayout>
            </AppMain>
        </AppLayoutContainer>
    )
}
export default AppLayout;